export const blockIconsSocialVaccinesNew = (
	<span className='material-symbols-outlined'>vaccines</span>
);
